import {betterMemo} from "js/common/utils/more-memo";
import React from "react";
import SimpleTextInput from "js/common/views/inputs/simple-text-input";

const DelayedNameInput = betterMemo(
    {displayName: "DelayedNameInput"},
    ({delayInMillis = 100, value, onChange, disabled, placeholder, customStyle}) => {
      const [str, setStr] = React.useState(value);
      React.useEffect(() => setStr(value), [value]);

      const timeoutIdRef = React.useRef(null);

      const flushChanges = () => {
        clearTimeout(timeoutIdRef.current);
        onChange(str.trim());
      };

      const handleChange = newStr => {
        setStr(newStr.substring(0, 64));

        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => {
          onChange(newStr);
        }, delayInMillis);
      };

      return <SimpleTextInput
          type="text"
          placeholder={placeholder}
          value={str}
          onClick={e => e.stopPropagation()}
          disabled={disabled}
          customStyle={{marginTop: 2, width: "500px", ...customStyle}}
          onBlur={flushChanges}
          onChange={handleChange}
      />;
    });

export default DelayedNameInput;